import React from "react";
import { motion } from "framer-motion";
import dotsPattern from "../../assets/dots-pattern.png"; // round dotted image
import shipImg from "../../assets/girlsteam.png"; // ship image
import videoThumb from "../../assets/boysteam.png"; // video thumbnail
import fortyThreeImg from "../../assets/plus.png"; // 43+ image
import "./ExperienceSection.css";

const ExperienceSection = () => {
  const isMobile = window.innerWidth <= 768; // breakpoint check

  return (
    <section className="experience-section">
      <div className="experience-container">
        
        {/* LEFT SIDE (Images) */}
        <motion.div
          className="experience-left"
          initial={isMobile ? false : { opacity: 0, x: -80 }}
          whileInView={isMobile ? {} : { opacity: 1, x: 0 }}
          transition={isMobile ? {} : { duration: 0.8, ease: "easeOut" }}
          viewport={isMobile ? {} : { once: false, amount: 0.3 }}
        >
          <img src={dotsPattern} alt="Pattern" className="experience-dots" />

          <div className="experience-ship">
            <img src={shipImg} alt="Ship" />
          </div>

          <div className="experience-video">
            <img src={videoThumb} alt="Video" />
            {/* <div className="experience-play-btn">▶</div> */}
            {/* <p className="experience-video-text">Our Activities</p> */}
          </div>
        </motion.div>

        {/* RIGHT SIDE (Content) */}
        <motion.div
          className="experience-right"
          initial={isMobile ? false : { opacity: 0, x: 80 }}
          whileInView={isMobile ? {} : { opacity: 1, x: 0 }}
          transition={isMobile ? {} : { duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={isMobile ? {} : { once: false, amount: 0.3 }}
        >
          <p className="experience-quote">
            We feel our function as distributors is not just to supply but to lead industries towards better, safer, and more advanced solutions.
          </p>

          <div className="experience-years">
            <img src={fortyThreeImg} alt="43+ Years" />
            <p>
              <span>Year of</span> <br /> Experience
            </p>
          </div>

          <div className="experience-desc">
            <h4>The Road Ahead</h4>
            <p>
              Industries are evolving — sustainability, innovation, and efficiency are now more important than ever. SE is embracing this future by expanding into eco-friendly coatings, next-generation specialty chemicals, grinding needs and sustainable industry materials.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ExperienceSection;
